import { render, staticRenderFns } from "./TaxRateForLandEditModal.vue?vue&type=template&id=657cf2ec&scoped=true&"
import script from "./TaxRateForLandEditModal.vue?vue&type=script&lang=js&"
export * from "./TaxRateForLandEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657cf2ec",
  null
  
)

export default component.exports